module.exports = __webpack_public_path__ + "assets/dotcms.30ca5b3a.svg";